export default {
  namespaced: true,
  region: {
    title: "state | states",
    name: "name",
    id: "ID",
    code: "code",
    acronym: "acronym"
  },
}
